import { useEffect } from 'react'

type RefType<T> =
  | ((instance: T | null) => void)
  | React.RefObject<T>
  | null
  | undefined

function useClickOutside<T extends HTMLElement>(
  ref: RefType<T>,
  handleClickOutside: () => void
) {
  useEffect(() => {
    function handleClick(event: MouseEvent) {
      if (
        ref &&
        'current' in ref &&
        ref.current &&
        !ref.current.contains(event.target as Node)
      ) {
        handleClickOutside()
      }
    }

    document.addEventListener('mousedown', handleClick)

    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [ref, handleClickOutside])
}

export default useClickOutside
